export const STATUS_TRANSFER_DEFAULT = 0;
export const STATUS_TRANSFER_ACCEPT = 1;
export const STATUS_TRANSFER_DECLINE = 2;

